import { useState } from "react";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { putPlacementWorksheetSettingsUnitComment } from "../../services/PlacementWorksheetApi";
import { usePlacementWorksheetTableRowContext } from "./PlacementWorksheetTableRowContext";

export const useInternalCommentsHandler = (unitId: number, withNofitications = true) => {
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const { setIsFinished } = usePlacementWorksheetTableRowContext();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { l2Id, l3Id, updateUnitComment } = usePlacementWorksheetContext();
  const { showErrorSnackbar } = useSnackbar();

  const handleError = () => {
    if (withNofitications) {
      showErrorSnackbar("An Error Occurred");
    }
  };

  const handleUpdate = async (comment: string | null) => {
    if (!l2Id || !l3Id || isSuperAdminRead()) return;
    setIsLoading(true);

    const handleSuccess = () => {
      updateUnitComment(unitId, comment);
      setIsFinished(true);
    };

    putPlacementWorksheetSettingsUnitComment(selectedNetworkId, l2Id, l3Id, unitId, comment, await getAuthToken())
      .then(handleSuccess)
      .catch(handleError)
      .finally(() => setIsLoading(false));
  };

  return {
    isLoading,
    handleUpdate,
  };
};
